import React, { useEffect, useState } from "react";
import s from "./Footer.module.css";
import mwali_logo from "../../assets/img/Mwali_security_logo.png";
import mailIcon from "../../assets/img/icon_mail.png";
import addressIcon from "../../assets/img/addressIcon.png";
import phoneIcon from "../../assets/img/icon_phone.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import { publicRoutes } from "../../router/PublicRoutes";
import { HOME } from "../../router/Constants";
import whatsapp from "../../assets/img/whatsapp.svg";
import telegram from "../../assets/img/telegram.svg";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const location = useLocation();
  const [isFooterHidden, setIsFooterHidden] = useState(true);
  const { t, i18n  } = useTranslation();

  useEffect(() => {
    if (location.pathname.includes("open_account") || location.pathname.includes("log_in")) {
      setIsFooterHidden(true);
    } else {
      setIsFooterHidden(false);
    }
  }, [location.pathname]);

  const phoneTo = () => {
    window.location.href = "tell:+37368626306";
    console.log("PHone number clicked");

  }

  return (
      <div className={s.wrapper}>
        {isFooterHidden ? (
            <div className={s.content_small}>
              <div className={s.footer_block}>
                <div className={s.copyright}>© {new Date().getFullYear()} Wall Street IBU</div>
              </div>
            </div>
        ) : (
            <div className={s.content} dir={i18n.language === 'fas' ? 'rtl' : 'ltr'}>
              <div className={s.footer_block}>
                <div className={s.title}>{t("footer.license.title")}</div>
                <img src={mwali_logo} alt={t("footer.license.alt")} />
                <div className={s.license_number}>{t("footer.license.number")}</div>
                <Link
                    to={"https://mwaliregistrar.com/list_of_entities/verify/434"}
                    target="_blank"
                    className={s.mwali_link}
                >
                  {t("footer.license.link")}
                </Link>
              </div>
              <div className={s.footer_block}>
                <div className={s.title}>{t("footer.legal.title")}</div>
                <div className={s.docs_block}>
                  <a className={s.doc_link} target="_blank" href={"/legalDocuments/Privacy_Policy.pdf"}>
                    {t("footer.legal.privacyPolicy")}
                  </a>
                  <a className={s.doc_link} target="_blank" href={"/legalDocuments/Website_Terms_and_Conditions.pdf"}>
                    {t("footer.legal.termsAndConditions")}
                  </a>
                  <a className={s.doc_link} target="_blank" href={"/legalDocuments/Corporate_Governance.pdf"}>
                    {t("footer.legal.corporateGovernance")}
                  </a>
                  <a className={s.doc_link} target="_blank" href={"/legalDocuments/Cookie_Policy.pdf"}>
                    {t("footer.legal.cookiePolicy")}
                  </a>
                  <a className={s.doc_link} target="_blank" href={"/legalDocuments/Bank_Transaction_Terms.pdf"}>
                    {t("footer.legal.bankTransactionsTerms")}
                  </a>
                  <a className={s.doc_link} target="_blank" href={"/legalDocuments/Debit_Card_Terms.pdf"}>
                    {t("footer.legal.debitCardTerms")}
                  </a>
                  <a className={s.doc_link} href={"#"}>
                    {t("footer.legal.standardFeesTariff")}
                  </a>
                </div>
              </div>
              <div className={s.footer_block}>
                <div className={s.title}>{t("footer.services.title")}</div>
                <div className={s.links_block}>
                  <NavLink className={s.footer_link} to={HOME} reloadDocument>
                    {t("footer.services.home")}
                  </NavLink>
                  {publicRoutes.map(item => (
                      <NavLink
                          to={item.path}
                          className={s.footer_link}
                          key={item.path}
                          reloadDocument
                      >
                        {t(item.titleKey)}
                      </NavLink>
                  ))}
                  <a href="https://alzafx.com" target="_blank" rel="noreferrer" className={s.footer_link}>
                    {t("footer.services.fxTrade")}
                  </a>
                </div>
              </div>
              <div className={s.footer_block}>
                <div className={s.title}>{t("footer.contact.title")}</div>
                <div className={s.mail_block}>
                  <img src={addressIcon} alt={t("footer.contact.addressIconAlt")}/>
                  <div className={s.mail}>
                    {t("footer.contact.address1")}
                  </div>
                </div>
                <div className={s.mail_block}>
                  <img src={mailIcon} alt={t("footer.contact.mailIconAlt")}/>
                  <a className={s.mail} href="mailto:info@wallstreetibu.com/">
                    info@wallstreetibu.com
                  </a>
                </div>
                <div className={s.mail_block}>
                  <img src={phoneIcon} alt={t("footer.contact.phoneIconAlt")}/>
                  <a href="tel:+37167314394" className={s.mail} dir='ltr'>+37167314394</a>
                </div>
                {/*<div className={s.mail_block}>*/}
                {/*  <img src={phoneIcon} alt={t("footer.contact.phoneIconAlt")}/>*/}
                {/*  <a href="tel:+989013752447" className={s.mail} dir='ltr'>+989013752447</a>*/}
                {/*</div>*/}
                <div className={s.social}>
                  <a href="https://wa.me/+35796145664" target="_blank">
                    <img src={whatsapp} alt="social_icon"/>
                  </a>
                  <a href="https://t.me/WallstreetIBU" target="_blank">
                    <img src={telegram} alt="social_icon"/>
                  </a>
                </div>
                <div className={s.swift_block}>
                  <a href="https://bank-code.net/swift-code/WSBOKMK1XXX.html">SWIFT: WSBOKMK1</a>
                </div>
                <div className={s.flex}>
                  {/* Additional content if needed */}
                </div>
                <div className={s.copyright}>© {new Date().getFullYear()} Wall Street IBU</div>
              </div>
            </div>
        )}
        <div className={s.content_small_mobile}>
          <div className={s.footer_block}>
            <div className={s.copyright}>© {new Date().getFullYear()} Wall Street IBU</div>
          </div>
        </div>
      </div>
  );
};

export default Footer;
